import React from "react";

// Internal Imports
import ReviewSlides from "./ReviewSlides";
import Carousel from "./index";

// CSS Imports
import carousel from "./carousel.module.scss";

const ReviewsCarousel = () => {
  return (
    <div className={carousel.authReviews}>
      <div className={carousel.authHeader}>
        <Carousel dataSlides={ReviewSlides} />
      </div>
    </div>
  );
};

export default ReviewsCarousel;
